import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const units = [
  "Cart 3",
  "Cart 5",
  "Cart 9",
  "Cart 12",
  "Cart 15",
  "Cart 17",

  "Tent 3",
  "Tent 5",
  "Tent 9",
  "Tent 12",
  "Tent 17",

  "Bike 1",
  "Bike 2",
  "Bike 3",

  "Transport 1",
  "Transport 2",
  "Transport 3",

  "Supervisor 1",
  "Supervisor 2",

  "Command 1",
  "Command 2",
  "Command 3",
];

function unitToSlug(unit) {
  return unit.toLowerCase().replace(/\s+/g, "-");
}

export default function ResponderLoginPage() {
  const [selectedUnit, setSelectedUnit] = useState("");
  const navigate = useNavigate();

  const handleLogin = () => {
    if (!selectedUnit) return;

    const unitSlug = unitToSlug(selectedUnit);

    // ✅ Save session
    sessionStorage.setItem(
      "fieldAccessSession",
      JSON.stringify({
        accessType: "responder",
        unitName: selectedUnit,
        unitSlug,
        loginTime: Date.now(),
      })
    );

    // ✅ Navigate to REAL responder page
    navigate(`/responder/${unitSlug}`);
  };

  return (
    <div style={styles.container}>

      <button
          onClick={() => navigate("/field-access")}
          style={styles.backBtn}
        >
          ← Back
        </button>

      <h2>Responder Login</h2>

      <select
        value={selectedUnit}
        onChange={(e) => setSelectedUnit(e.target.value)}
        style={styles.select}
      >
        <option value="">Select Unit</option>
        {units.map((unit) => (
          <option key={unit} value={unit}>
            {unit}
          </option>
        ))}
      </select>

      <button onClick={handleLogin} style={styles.button}>
        Enter
      </button>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
  },
  select: {
    padding: 10,
    fontSize: 16,
    width: 200,
  },
  backBtn: {
  background: "transparent",
  border: "1px solid #cbd5e1",
  padding: "6px 10px",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 700,
},
  button: {
    padding: 12,
    width: 200,
    background: "#1e7a6f",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
  },
};